const index = () => import("@/view/index")
const ademo = () => import("@/view/ademo/ceshi") //demo表
const common_pdf = () => import("@/view/common/common-pdf") //common页面-公用pdf查看页面
const no_power = () => import("@/view/nopower")
const project_list = () => import("@/view/tender/project/project-list") //项目入场登记
const project_list_nodemand = () => import("@/view/tender/project/project-list-nodemand")
const project_edit = () => import("@/view/tender/project/project-edit")
const selectpurchaser_name = () => import("@/view/tender/project/component/selectpurchaser-name")
const project_approval_list = () => import("@/view/tender/projectapproval/project-approval-list") //项目入场登记核验
const project_approval = () => import("@/view/tender/projectapproval/project-approval")
const procrement_file_approval_list = () => import("@/view/tender/procrementfileapproval/procrement-file-approval-list") //采购文件确认/采购文件核验
const purchase_file_approval_list = () => import("@/view/tender/procrementfileapproval/purchase-file-approval-list") //采购公告及文件文件核验
const procrement_file_approval_view = () => import("@/view/tender/procrementfileapproval/procrement-file-detail-view") //公开-采购文件核验
const procrement_file_approval_contest_view = () => import("@/view/tender/procrementfileapproval/contest/procrement-file-detail-contest-view") //竞谈-谈判文件核验
const procrement_notice_contest_invitation_view = () => import("@/view/tender/procrementfileapproval/contest/procrement-notice-contest-invitation-view") // 竞谈-谈判邀请书核验
const procrement_file_approval_inquiry_view = () => import("@/view/tender/procrementfileapproval/inquiry/procrement-file-detail-inquiry-view") //询价-询价文件核验页面
const procrement_file_approval_inquiry_invitation_view = () => import("@/view/tender/procrementfileapproval/inquiry/procrement-file-detail-inquiry-invitation-view") //询价-询价文件邀请书
const procrement_file_approval_competition_view = () => import("@/view/tender/procrementfileapproval/competition/procrement-file-detail-competition-view") //竞磋-竞磋文件核验页面
const procrement_file_approval_notcarry_view = () => import("@/view/tender/procrementfileapproval/procrement/procrement-file-detail-notcarry-view") //公开不走执行通知书 核验页面
const procrement_file_detail_competition_intitation_view = () => import("@/view/tender/procrementfileapproval/competition/intitation/procrement-file-detail-competition-intitation-view") // 竞磋-竞磋邀请书核验页面
const procrement_file_approval_onesource_view = () => import("@/view/tender/procrementfileapproval/onesource/procrement-file-detail-onesource-view") //单一来源
//采购需求编制-list
const purchase_demand_list = () => import("@/view/tender/purchasedemand/purchase-demand-list")
//采购需求编制-编辑-竞谈
const purchase_demand_detail_jt_edit = () => import("@/view/tender/purchasedemand/purchase-demand-detail-jt-edit")
//采购需求编制-查看-竞谈
const purchase_demand_detail_jt_view = () => import("@/view/tender/purchasedemand/purchase-demand-detail-jt-view")
//采购需求确认-list
const purchase_demand_confirm_list = () => import("@/view/tender/purchasedemandconfirm/purchase-demand-confirm-list")
const purchase_demand_detail_approval_view = () => import("@/view/tender/purchasedemandconfirm/purchase-demand-detail-approval-view")
//采购需求公示
const purchase_demand_notice_list = () => import("@/view/tender/purchasedemandnotice/purchase-demand-notice-list")
//采购需求公示编制
const purchase_demand_notice_edit = () => import("@/view/tender/purchasedemandnotice/purchase-demand-notice-edit")
//采购需求公示查看
const purchase_demand_notice_view = () => import("@/view/tender/purchasedemandnotice/purchase-demand-notice-view")
//采购需求公示pdf预览
const purchase_demand_notice_pdf = () => import("@/view/tender/purchasedemandnotice/purchase-demand-notice-pdf")
//单一来源采购公示申请list
const notice_apply_list = () => import("@/view/tender/noticeapply/notice-apply-list")
const notice_apply_edit = () => import("@/view/tender/noticeapply/notice-apply-edit")
const notice_apply_view = () => import("@/view/tender/noticeapply/notice-apply-view")
//单一来源公示核验
const single_source_notice_approval_list = () => import("@/view/tender/singlesourcenoticeapproval/single-source-notice-approval-list")
const single_source_notice_approval_view = () => import("@/view/tender/singlesourcenoticeapproval/single-source-notice-approval-view")
const single_source_notice_approval_apply_view = () => import("@/view/tender/singlesourcenoticeapproval/single-source-notice-approval-apply-view")
//采购需求公示核验_list
const purchase_demand_notice_approval_list = () => import("@/view/tender/purchasedemandnoticeapproval/purchase-demand-notice-approval-list")
const purchase_demand_notice_approval_view = () => import("@/view/tender/purchasedemandnoticeapproval/purchase-demand-notice-approval-view")
// 执行通知书-list
const carry_out_notice_list = () => import("@/view/tender/carryoutnotice/carry-out-notice-list")
// 执行通知书-edit
const carry_out_notice_edit = () => import("@/view/tender/carryoutnotice/carry-out-notice-edit")
//执行通知书选择采购代理弹框
const selectpurchaser_agency_name = () => import("@/view/tender/carryoutnotice/selectpurchaser-agency-name")
// 委托代理协议-采购人-list
const agency_agreement_list = () => import("@/view/tender/carryoutnotice/agency-agreement-list")
// 委托代理协议-采购人-list
const agency_agreement_list_jzr = () => import("@/view/tender/carryoutnotice/agency-agreement-list-jzr")
// 委托代理协议-项目负责人-list
const agency_agreement_list_agency = () => import("@/view/tender/carryoutnotice/agency-agreement-list-agency")
const agency_agreement_list_agency_edit = () => import("@/view/tender/carryoutnotice/agency-agreement-list-detail")
const agency_agreement_list_agency_check = () => import("@/view/tender/carryoutnotice/agency-agreement-list-check")
const agency_agreement_list_check = () => import("@/view/tender/carryoutnotice/agency-agreement-check")
// 委托代理协议-edit
const agency_agreement_edit = () => import("@/view/tender/carryoutnotice/agency-agreement-edit")
//合同公示核验-approve
const contract_publicity_verification_approve = () => import("@/view/contract/contractpublicityverification/contract-publicity-verification-approve")
//合同公示核验-list
const contract_publicity_verification_list = () => import("@/view/contract/contractpublicityverification/contract-publicity-verification-list")
//合同公示核验-view
const contract_publicity_verification_view = () => import("@/view/contract/contractpublicityverification/contract-publicity-verification-view")
//合同公示pdf-view
const contract_publicity_verification_pdf = () => import("@/view/contract/contractpublicityverification/contract-publicity-verification-pdf")
//专家抽取申请-list
const enpert_application_list = () => import("@/view/tender/expertapplication/enpert-application-list")
//专家抽取申请-edit
const enpert_application_edit = () => import("@/view/tender/expertapplication/enpert-application-edit")
const enpert_application_view = () => import("@/view/tender/expertapplication/enpert-application-view")
// 委托代理协议pdf预览页面
const agency_agreement_pdf = () => import("@/view/tender/carryoutnotice/agency-agreement-pdf")
// 执行通知书受理-list
const carry_out_notice_acceptance_list = () => import("@/view/tender/carryoutnoticeacceptance/carry-out-notice-acceptance-list")
// 执行通知书受理-view
const carry_out_notice_acceptance_view = () => import("@/view/tender/carryoutnoticeacceptance/carry-out-notice-acceptance-view")
// 委托代理协议pdf预览页面
const agency_agreement_acceptance_pdf = () => import("@/view/tender/carryoutnoticeacceptance/agency-agreement-acceptance-pdf")
// 执行通知书任务分派列表页面
const carry_out_notice_assign_list = () => import("@/view/tender/carryoutnoticeassign/carry-out-notice-assign-list")
// 分散采购任务分派列表页面
const carry_out_notice_de_assign_list = () => import("@/view/tender/carryoutnoticedeassign/carry-out-notice-de-assign-list")
// 分散采购任务分派列表页面
const distribution_list = () => import("@/view/tender/distribution/distribution-list")
// 分散采购任务分派列表页面-项目负责人确认模块
const distribution_list_confirm = () => import("@/view/tender/distribution/distribution-list-principal-confirm")
// 项目信息查看
const distribution_project_info = () => import("@/view/tender/distribution/distribution-project-info")
// 执行通知书任务分派列表页面
const carry_out_notice_assign_view = () => import("@/view/tender/carryoutnoticeassign/carry-out-notice-assign-view")
// 分散采购任务分派列表页面
const carry_out_notice_de_assign_view = () => import("@/view/tender/carryoutnoticedeassign/carry-out-notice-de-assign-view")
//执行通知书查阅页面
const carry_out_notice_read_list = () => import("@/view/tender/carryoutnoticeread/carry-out-notice-read-list")
// 执行通知书任务分派列表确认页面
const carry_out_notice_assign_confirm_list = () => import("@/view/tender/carryoutnoticeassignconfirm/carry-out-notice-assign-confirm-list")
//标中任务分派
const project_assign_list = () => import("@/view/evaluation/projectassign/project-assign-list")
//标中任务分派确认
const project_assign_confirm_list = () => import("@/view/evaluation/projectassignconfirm/project-assign-confirm-list")
const purchaser_project_management_list = () => import("@/view/tender/purchaserprojectmanagement/purchaser-project-management-list")
// 标书下载及报名  列表
const bid_document_list = () => import("@/view/bidding/biddocument/bid-document-list")
// 标书下载及报名  编辑
const bid_document_edit = () => import("@/view/bidding/biddocument/bid-document-edit")
// 标书下载及联合体报名  编辑
const bid_unitdocument_edit = () => import("@/view/bidding/biddocument/bid-unitdocument-edit")
// 标书下载及报名  我的投标 查看
const bid_document_registerform_view = () => import("@/view/bidding/biddocument/bid-document-registerform-view")
// 标书下载及报名  查看
const bid_document_view = () => import("@/view/bidding/biddocument/bid-document-view")
// 标书下载及报名  查看
const bid_unitdocument_view = () => import("@/view/bidding/biddocument/bid-unitdocument-view")
// 标书下载及报名  采购公告查看
const procrement_notice_reserve = () => import("@/view/bidding/biddocument/procrement-notice-reserve")
// 组件联合体列表
const bid_joint_list = () => import("@/view/bidding/bidjoint/bid-joint-list")
//查看报名情况
const enroll_view_list = () => import("@/view/bidding/enrollview/enroll-view-list")
//查看报名情况-领导
const enroll_view_leader_list = () => import("@/view/bidding/enrollview/enroll-view-leader-list")

// 我的投标项目管理列表
const register_manage_list = () => import("@/view/bidding/registermanage/register-manage-list")
// 我的投标项目编辑页面
const register_manage_view = () => import("@/view/bidding/registermanage/register-manage-view")
//项目备案申请列表
const project_filing_list = () => import("@/view/contract/projectfiling/project-filing-list")
const project_filing_edit = () => import("@/view/contract/projectfiling/project-filing-edit")
const project_filing_view = () => import("@/view/contract/projectfiling/project-filing-view")
const project_filing_jgbmshow = () => import("@/view/contract/projectfiling/project-filing-jgbmshow")
const project_filing_cgrshow = () => import("@/view/contract/projectfiling/project-filing-cgrshow")
//资审公告编制
const qualification_audit_contest_pdf = () => import("@/view/tender/qualificationauditnotice/qualification-audit-contest-pdf")
//资审公告核验
const qualification_audit_approval_list = () => import("@/view/tender/qualificationauditnoticeapproval/qualification-audit-approval-list")
const qualification_audit_approval_view = () => import("@/view/tender/qualificationauditnoticeapproval/qualification-audit-approval-view")
/*邀请书及文件编制-开始*/
//投标
const procrement_file_detail_invitation_bid_notice = () => import("@/view/tender/procrementfiledetail/invitation/bid/view/notice")
const procrement_file_detail_invitation_bid_company = () => import("@/view/tender/procrementfiledetail/invitation/bid/view/company")
const procrement_file_detail_invitation_bid_file = () => import("@/view/tender/procrementfiledetail/invitation/bid/view/file")
//竟磋
const procrement_file_detail_invitation_competition_notice = () => import("@/view/tender/procrementfiledetail/invitation/competition/view/notice")
const procrement_file_detail_invitation_competition_company = () => import("@/view/tender/procrementfiledetail/invitation/competition/view/company")
const procrement_file_detail_invitation_competition_file = () => import("@/view/tender/procrementfiledetail/invitation/competition/view/file")
//竟谈
const procrement_file_detail_invitation_negotiation_notice = () => import("@/view/tender/procrementfiledetail/invitation/negotiation/view/notice")
const procrement_file_detail_invitation_negotiation_company = () => import("@/view/tender/procrementfiledetail/invitation/negotiation/view/company")
const procrement_file_detail_invitation_negotiation_file = () => import("@/view/tender/procrementfiledetail/invitation/negotiation/view/file")
//询价
const procrement_file_detail_invitation_inquiry_notice = () => import("@/view/tender/procrementfiledetail/invitation/inquiry/view/notice")
const procrement_file_detail_invitation_inquiry_company = () => import("@/view/tender/procrementfiledetail/invitation/inquiry/view/company")
const procrement_file_detail_invitation_inquiry_file = () => import("@/view/tender/procrementfiledetail/invitation/inquiry/view/file")
//单一信封
const procrement_file_detail_invitation_onesource_notice = () => import("@/view/tender/procrementfiledetail/invitation/onesource/view/notice")
const procrement_file_detail_invitation_onesource_company = () => import("@/view/tender/procrementfiledetail/invitation/onesource/view/company")
const procrement_file_detail_invitation_onesource_file = () => import("@/view/tender/procrementfiledetail/invitation/onesource/view/file")
//预审
const procrement_file_detail_invitation_pretrial_notice = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/view/notice")
const procrement_file_detail_invitation_pretrial_company = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/view/company")
const procrement_file_detail_invitation_pretrial_file = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/view/file")
//核验-列表
const procrement_file_invitation_approval_list = () => import("@/view/tender/procrementfileapproval/invitation/procrement-file-invitation-approval-list")
/*邀请书及文件编制-结束*/
//资审公告及文件编制
const procrement_file_detail_review_notice = () => import("@/view/tender/procrementfiledetail/proclamationreview/notice")
const procrement_file_detail_review_file = () => import("@/view/tender/procrementfiledetail/proclamationreview/file")
//资审公告及文件核验
const procrement_file_review_approval_list = () => import("@/view/tender/procrementfiledetail/proclamationreview/verification")
//采购公告及文件编制
const procrement_file_detail_notice = () => import("@/view/tender/procrementfiledetail/purchase/notice")
const procrement_file_detail_file = () => import("@/view/tender/procrementfiledetail/purchase/file")
//磋商公告及文件编制
const procrement_file_detail_competition_notice = () => import("@/view/tender/procrementfiledetail/competition/view/notice")
const procrement_file_detail_competition_file = () => import("@/view/tender/procrementfiledetail/competition/view/file")
//谈判公告及文件编制
const procrement_file_detail_negotiation_notice = () => import("@/view/tender/procrementfiledetail/negotiation/view/notice")
const procrement_file_detail_negotiation_file = () => import("@/view/tender/procrementfiledetail/negotiation/view/file") //询价-公告及文件编制
const procrement_file_detail_inquiry_notice = () => import("@/view/tender/procrementfiledetail/inquiry/view/notice")
const procrement_file_detail_inquiry_file = () => import("@/view/tender/procrementfiledetail/inquiry/view/file")
const procrement_notice_pdf = () => import("@/view/tender/procrementfiledetail/procrement-notice-pdf")
//单一来源公告及文件编制
const procrement_file_detail_onesource_notice = () => import("@/view/tender/procrementfiledetail/onesource/view/notice")
const procrement_file_detail_onesource_file = () => import("@/view/tender/procrementfiledetail/onesource/view/file")
//查看中标通知书
const bid_notice_list = () => import("@/view/bidding/notice/list")
// 邀请书路由开始
// 邀请后审核验页面
const procrement_notice_invitation_pretrial_view = () => import("@/view/tender/procrementfileapproval/invitation/procrement-notice-invitation-pretrial-view")
// 邀请预审核验页面
const procrement_notice_invitation_two_envelope_view = () => import("@/view/tender/procrementfileapproval/invitation/procrement-notice-invitation-two-envelope-view")
// 供应商查看邀请书页面信息
const bid_invitation_pdf = () => import("@/view/tender/procrementfiledetail/bid-invitation-pdf")
// 邀请书路由结束
// 项目异常处理开始

const project_stop_list = () => import("@/view/exception/projectstop/project-stop-list")

const purchaser_project_stop_list = () => import("@/view/exception/purchaserprojectstop/purchaser-project-stop-list")

const purchaser_project_stop_edit = () => import("@/view/exception/purchaserprojectstop/purchaser-project-stop-edit")

const manager_project_stop_approval_list = () => import("@/view/exception/managerprojectstopapproval/manager-project-stop-approval-list")

const manager_project_stop_approval_edit = () => import("@/view/exception/managerprojectstopapproval/manager-project-stop-approval-edit")

const project_stop_edit = () => import("@/view/exception/projectstop/project-stop-edit")

const project_stop_view = () => import("@/view/exception/projectstop/project-stop-view")

const project_stop_approval_view = () => import("@/view/exception/projectstopapproavl/project-stop-approval-view")

const project_stop_approval_list = () => import("@/view/exception/projectstopapproavl/project-stop-approval-list")

const project_stop_approval_edit = () => import("@/view/exception/projectstopapproavl/project-stop-approval-edit")

const nullifield_bid_approval_list = () => import("@/view/exception/nullifieldbidapproval/nullifield-bid-approval-list")

const nullifield_bid_approval_edit = () => import("@/view/exception/nullifieldbidapproval/nullifield-bid-approval-edit")

const nullifield_bid_approval_view = () => import("@/view/exception/nullifieldbidapproval/nullifield-bid-approval-view")

const project_pause_resumed_list = () => import("@/view/exception/projectpauseresumed/project-pause-resumed-list")

const purchaser_project_pause_resumed_list = () => import("@/view/exception/purchaserprojectpauseresumed/purchaser-project-pause-resumed-list")

const project_pause_edit = () => import("@/view/exception/projectpauseresumed/project-pause-edit")

const purchaser_project_pause_edit = () => import("@/view/exception/purchaserprojectpauseresumed/purchaser-project-pause-edit")

const project_pause_pdf = () => import("@/view/exception/projectpauseresumed/project-pause-pdf")

const purchaser_project_pause_pdf = () => import("@/view/exception/purchaserprojectpauseresumed/purchaser-project-pause-pdf")

const purchaser_project_resumed_pdf = () => import("@/view/exception/purchaserprojectpauseresumed/purchaser-project-resumed-pdf")

const project_resumed_pdf = () => import("@/view/exception/projectpauseresumed/project-resumed-pdf")

const purchaser_project_resumed_edit = () => import("@/view/exception/purchaserprojectpauseresumed/purchaser-project-resumed-edit")

const project_resumed_edit = () => import("@/view/exception/projectpauseresumed/project-resumed-edit")

const project_pause_resumed_approval_list = () => import("@/view/exception/projectpauseresumedapproval/project-pause-resumed-approval-list")

const manager_project_pause_resumed_approval_list = () => import("@/view/exception/managerprojectpauseresumedapproval/manager-project-pause-resumed-approval-list")
//保函索赔申请
const guarantee_letter_claim_list = () => import("@/view/exception/guaranteeLetterClaim/list")
const guarantee_letter_claim_info = () => import("@/view/exception/guaranteeLetterClaim/info")

//保函索赔申请核验
const guarantee_letter_claim_approval = () => import("@/view/exception/guaranteeLetterClaim/approval")

const project_pause_approval_edit = () => import("@/view/exception/projectpauseresumedapproval/project-pause-approval-edit")
const manager_project_pause_approval_edit = () => import("@/view/exception/managerprojectpauseresumedapproval/manager-project-pause-approval-edit")
const project_pause_approval_pdf = () => import("@/view/exception/projectpauseresumedapproval/project-pause-approval-pdf")
const project_resumed_approval_pdf = () => import("@/view/exception/projectpauseresumedapproval/project-resumed-approval-pdf")
const manager_project_resumed_approval_pdf = () => import("@/view/exception/managerprojectpauseresumedapproval/manager-project-resumed-approval-pdf")
const project_resumed_approval_edit = () => import("@/view/exception/projectpauseresumedapproval/project-resumed-approval-edit")
const manager_project_resumed_approval_edit = () => import("@/view/exception/managerprojectpauseresumedapproval/manager-project-resumed-approval-edit")
// 项目处理结束
//确定中标人-edit
const confirm_win_bidder_edit = () => import("@/view/awardnotice/confirmWinBidder/confirm-win-bidder-edit")
//交易情况统计
const transactionstatus_edit = () => import("@/view/awardnotice/transactionstatus/status-edit")
const transactionstatus_list = () => import("@/view/awardnotice/transactionstatus/status-list")

//确定中标人-list
const confirm_win_bidder_list = () => import("@/view/awardnotice/confirmWinBidder/confirm-win-bidder-list")
//中标结果公告-release
const win_bid_announcement_release = () => import("@/view/awardnotice/winbidannouncement/win-bid-announcement-release")
//中标结果公告核验-list
const win_bid_announcement_approve_list = () => import("@/view/awardnotice/winbidannouncementapprove/win-bid-announcement-approve-list")
//中标结果公告核验-edit
const win_bid_announcement_approve_edit = () => import("@/view/awardnotice/winbidannouncementapprove/win-bid-announcement-approve-edit")
//评审结果核验-list
const evaluation_bid_result_approve_list = () => import("@/view/evalBidResultVerification/evaluation-bid-result-approve-list")
//评审结果核验-edit
const evaluation_bid_result_approve_edit = () => import("@/view/evalBidResultVerification/evaluation-bid-result-approve-edit")

//回执单
const receipt_record = () => import("@/view/bidding/receiptrecord/receipt-record")

const modify_notice_pdf = () => import("@/view/tender/modifynotice/modify-notice-pdf")
const qualification_audit_notice_modify_pdf = () => import("@/view/tender/qualificationauditnoticemodify/qualification-audit-notice-modify-pdf")

//合同公示-采购人

const contract_publicity_cgr_list = () => import("@/view/contract/contractpublicitycgr/contract-publicity-cgr-list")

const contract_publicity_cgr_edit = () => import("@/view/contract/contractpublicitycgr/contract-publicity-cgr-edit")

const contract_publicity_cgr_view = () => import("@/view/contract/contractpublicitycgr/contract-publicity-cgr-view")

const contract_publicity_cgr_pdf = () => import("@/view/contract/contractpublicitycgr/contract-publicity-cgr-pdf")

const contract_publicity_pdfcgr = () => import("@/view/contract/contractpublicitycgr/contract-publicity-pdfcgr")
//在线签订合同

const sign_contracts_online = () => import("@/view/contract/signcontractsonline/index")
// 合同編制
const sign_contracts_online_organization = () => import("@/view/contract/signcontractsonline/organization/organization")
const sign_contracts_online_organization_view = () => import("@/view/contract/signcontractsonline/organization/organization-view")
const sign_contracts_online_organization_edit = () => import("@/view/contract/signcontractsonline/organization/organization-edit")
const sign_contracts_online_organization_pdf = () => import("@/view/contract/signcontractsonline/organization/organization-pdf")
//合同查询
const sign_contracts_online_see = () => import("@/view/contract/signcontractsonline/see/see")
const sign_contracts_online_see_view = () => import("@/view/contract/signcontractsonline/see/see-view")
//合同确认
const sign_contracts_online_sure = () => import("@/view/contract/signcontractsonline/sure/sure")
const sign_contracts_online_sure_view = () => import("@/view/contract/signcontractsonline/sure/sure-view")
//合同核验
const sign_contracts_online_check = () => import("@/view/contract/signcontractsonline/check/check")
const sign_contracts_online_check_view = () => import("@/view/contract/signcontractsonline/check/check-view")

//互评
//评价采购人
const evaluate_purchaser_list = () => import("@/view/contract/evaluate/evaluate-purchaser/evaluate-purchaser-list")
const evaluate_purchaser_list_edit = () => import("@/view/contract/evaluate/evaluate-purchaser/evaluate-purchaser-edit")
const evaluate_purchaser_list_view = () => import("@/view/contract/evaluate/evaluate-purchaser/evaluate-purchaser-view")
//评价供应商
const evaluate_suppliers_list = () => import("@/view/contract/evaluate/evaluate-suppliers/evaluate-suppliers-list")
const evaluate_suppliers_list_edit = () => import("@/view/contract/evaluate/evaluate-suppliers/evaluate-suppliers-edit")
const evaluate_suppliers_list_view = () => import("@/view/contract/evaluate/evaluate-suppliers/evaluate-suppliers-view")
//相关方互评
const interested_parties_list = () => import("@/view/contract/evaluate/interested_parties/interested-parties-list")
const interested_parties_view = () => import("@/view/contract/evaluate/interested_parties/interested-parties-view")

//质疑答复核验开始

const answer_reply_approval_list = () => import("@/view/bidding/answerReplyApproval/answer-newList")

//质疑答复核验结束

//供应商质疑-list
//供应商质疑-list

const question_list = () => import("@/view/bidding/question/question-list")
//供应商质疑-edit

const question_edit = () => import("@/view/bidding/question/question-edit")
//供应商质疑-view

const question_view = () => import("@/view/bidding/question/question-view")

//供应商质疑-release
const question_other = () => import("@/view/bidding/question/question-other")

const question_release = () => import("@/view/bidding/question/question-release")
//供应商质疑回复 采购人-list

const answer_list = () => import("@/view/bidding/answer/answer-tabs-list")
//供应商质疑回复采购人-reply

const answer_reply = () => import("@/view/bidding/answer/answer-reply")
//供应商质疑回复采购人-detail

const answer_detail = () => import("@/view/bidding/answer/answer-detail")
//供应商质疑回复采购人-receipt

const answer_offline_edit = () => import("@/view/bidding/answer/answer-offline-edit")

const answer_publicity = () => import("@/view/bidding/publicity/answer-publicity-list")
//质疑公示列表

const publicity_edit = () => import("@/view/bidding/publicity/answer-publicity-edit")
//质疑公示列表
const publicity_view = () => import("@/view/bidding/publicity/answer-publicity-view")

const publicity_check = () => import("@/view/bidding/publicity/answer-publicity-check")

const publicity_approve = () => import("@/view/bidding/publicity/answer-publicity-approve")

const answer_receipt = () => import("@/view/bidding/answer/answer-receipt")

//质疑询问
const answer_query = () => import("@/view/bidding/query/answer-query/answer-query-list")
const answer_query_edit = () => import("@/view/bidding/query/answer-query/answer-query-edit")
const answer_query_view = () => import("@/view/bidding/query/answer-query/answer-query-view")
const answer_query_release = () => import("@/view/bidding/query/answer-query/answer-query-release")
const answer_reply_list = () => import("@/view/bidding/query/answer-reply/answer-reply-list")
const answer_reply_edit = () => import("@/view/bidding/query/answer-reply/answer-reply-edit")
const answer_reply_view = () => import("@/view/bidding/query/answer-reply/answer-reply-view")
const answer_query_reply = () => import("@/view/bidding/query/answer-query/answer-query-reply")
const answer_query_check = () => import("@/view/bidding/query/answer-query/answer-query-check")
const answer_query_approve = () => import("@/view/bidding/query/answer-query/answer-query-approve")
const answer_query_approve_release = () => import("@/view/bidding/query/answer-query/answer-query-approve-release")

//踏勘结果登记采购人-list

const survey_result_record_cgr_list = () => import("@/view/tender/surveyresultrecordcgr/survey-result-record-cgr-list")
//踏勘结果登记采购人-edit

const survey_result_record_cgr_edit = () => import("@/view/tender/surveyresultrecordcgr/survey-result-record-cgr-edit")
//踏勘结果登记采购人-view

const survey_result_record_cgr_view = () => import("@/view/tender/surveyresultrecordcgr/survey-result-record-cgr-view")
//信息更正公告核验
const modify_notice_approve_list = () => import("@/view/tender/modifynoticeapprove/modify-notice-approve-list")
const modify_notice_approve_view = () => import("@/view/tender/modifynoticeapprove/modify-notice-approve-view")
//资审公告核验
const qualification_audit_modify_notice_approve_list = () => import("@/view/tender/qualificationauditnoticemodifyapprove/qualification-audit-modify-notice-approve-list")
const qualification_audit_modify_notice_approve_view = () => import("@/view/tender/qualificationauditnoticemodifyapprove/qualification-audit-modify-notice-approve-view")
//项目进程总览
const project_overview = () => import("@/view/tender/projectoverview/project-overview")
const project_overview_list = () => import("@/view/tender/projectoverview/project-overview-list")
const win_bid_notice_modify_approval_view_pdf = () => import("@/view/awardnotice/winbidnoticemodifyapprove/win-bid-notice-modify-approval-view-pdf")
//供应商查看标后更正公告
const win_bid_notice_modify_release = () => import("@/view/awardnotice/winbidnoticemodify/win-bid-notice-modify-release")
//标后更正公告核验列表
const win_bid_notice_modify_approve_list = () => import("@/view/awardnotice/winbidnoticemodifyapprove/win-bid-notice-modify-approve-list")
//工作分派列表
const project_approve_assign_list = () => import("@/view/tender/workassign/list")

const win_bid_notice_modify_approve_view = () => import("@/view/awardnotice/winbidnoticemodifyapprove/win-bid-notice-modify-approve-view")
//复评申请核验
const reaccreditation_apply_approval_list = () => import("@/view/evaluation/reaccreditationapplyapproval/reaccreditation-apply-approval-list")
const reaccreditation_apply_approval_view = () => import("@/view/evaluation/reaccreditationapplyapproval/reaccreditation-apply-approval-view")
//项目更正申请
const project_correction_list = () => import("@/view/tender/projectcorrection/project-correction-list")
const project_correction_edit = () => import("@/view/tender/projectcorrection/project-correction-edit")
//项目更正申请
const qualification_audit_correction_list = () => import("@/view/tender/qualificationauditnoticecorrection/qualification-audit-correction-list")
const qualification_audit_correction_edit = () => import("@/view/tender/qualificationauditnoticecorrection/qualification-audit-correction-edit")
//变更评委申请核验list
const change_judge_application_approve_list = () => import("@/view/evaluation/changejudgeapplicationapprove/change-judge-application-approve-list")
//变更评委申请核验edit
const change_judge_application_approve_edit = () => import("@/view/evaluation/changejudgeapplicationapprove/change-judge-application-approve-edit")
//变更采购方式核验list
const change_purchaser_mode_approve_list = () => import("@/view/evaluation/changepurchasermodeapprove/change-purchaser-mode-approve-list")
//变更采购方式核验edit
const change_purchaser_mode_approve_edit = () => import("@/view/evaluation/changepurchasermodeapprove/change-purchaser-mode-approve-edit")
//采购需求询问-list
const purchase_demand_query_list = () => import("@/view/tender/purchasedemandquery/purchase-demand-query-list")
//采购需求询问-edit
const purchase_demand_query_edit = () => import("@/view/tender/purchasedemandquery/purchase-demand-query-edit")
//采购需求询问-view
const purchase_demand_query_view = () => import("@/view/tender/purchasedemandquery/purchase-demand-query-view")
//采购需求答疑-list
const purchase_demand_answer_list = () => import("@/view/tender/purchasedemandanswer/purchase-demand-answer-list")
//采购需求答疑-view
const purchase_demand_answer_enterprise_list = () => import("@/view/tender/purchasedemandanswer/purchase-demand-answer-enterprise-list")
//履约登记-list
const implementation_list = () => import("@/view/contract/implementation/implementation-list")
//履约登记-edit
const implementation_edit = () => import("@/view/contract/implementation/implementation-edit")
//履约登记-view
const implementation_view = () => import("@/view/contract/implementation/implementation-view")
//履约登记-list  角色区分
const implementation_role_list = () => import("@/view/contract/implementation/implementation-role-list")
//履约登记-view  角色区分
const implementation_role_view = () => import("@/view/contract/implementation/implementation-role-view")
//投诉-view
const complaint_view = () => import("@/view/bidding/complaint/complaint-view")
//投诉-edit
const complaint_edit = () => import("@/view/bidding/complaint/complaint-edit")
//投诉-list
const complaint_list = () => import("@/view/bidding/complaint/complaint-list")
//投诉-view
const complaint_answer_view = () => import("@/view/bidding/complaintanswer/complaint-answer-view")
//投诉-edit
const complaint_answer_edit = () => import("@/view/bidding/complaintanswer/complaint-answer-edit")
//投诉-list
const complaint_answer_list = () => import("@/view/bidding/complaintanswer/complaint-answer-list")
//在线投诉-view
const complaint_online_view = () => import("@/view/bidding/complaintOnLine/complaint-view")
//在线投诉-edit
const complaint_online_edit = () => import("@/view/bidding/complaintOnLine/complaint-edit")
//在线投诉-list
const complaint_online_list = () => import("@/view/bidding/complaintOnLine/complaint-list")
const venue_book = () => import("@/view/tender/venuebook/index")
const venue_book_info = () => import("@/view/tender/venuebook/src/info")
const venue_book_verification = () => import("@/view/tender/venuebook/src/verification")
//资审场地预约
const venue_book_review = () => import("@/view/tender/venuebookreview/index")
const venue_book_review_info = () => import("@/view/tender/venuebookreview/src/info")
const venue_book_review_verification = () => import("@/view/tender/venuebookreview/src/verification")
//采购人推荐供应商
const recommended_supplier_edit = () => import("@/view/tender/recommendedsupplier/recommended-supplier-edit")
//采购人推荐供应商
const recommended_supplier_view = () => import("@/view/tender/recommendedsupplier/recommended-supplier-view")
const recommended_supplier_list = () => import("@/view/tender/recommendedsupplier/recommended-supplier-list")
const filed_node_list = () => import("@/view/exception/filednode/filed-node-list")
const filed_type_list = () => import("@/view/exception/filedType/filed-type-list")
// 项目菜单驱动路由配置结束
const project_filed_list = () => import("@/view/exception/projectfiled/project-filed-list")
const project_filed_list_all = () => import("@/view/exception/projectfiled/project-filed-list-all")
const project_filed_view_index = () => import("@/view/exception/projectfiled/project-filed-view-index")
/**公告抽取页面 */
//信息更正公告
const notice_modify_notice_pdf = () => import("@/view/noticepdf/notice-modify-notice-pdf")
const notice_win_bid_announcement_release = () => import("@/view/noticepdf/notice-win-bid-announcement-release")
const notice_win_bid_notice_modify_pdf = () => import("@/view/noticepdf/notice-win-bid-notice-modify-pdf")
//保证金
const return_guarantee_list = () => import("@/view/tender/returnguarantee/return-guarantee-list")
const return_guarantee_info = () => import("@/view/tender/returnguarantee/return-guarantee-info")
const check_return_list = () => import("@/view/tender/checkreturn/check-return-list")
const return_guarantee_approval_list = () => import("@/view/tender/returnguarantee/return-guarantee-approval-list")

const nullifield_bid_pdf_view = () => import("@/view/exception/nullifieldbid/nullifield-bid-view")

//待办事项
const todo_statistics = () => import("@/view/tender/todostatistics/list")
//采购文件核验列表
const purchase_file_verification_list = () => import("@/view/fileVerification/purchase-file-verification-list")
//资审文件核验列表
const information_file_verification_list = () => import("@/view/fileVerification/information-file-verification-list")
//采购文件上传和核验
const purchase_file_verification_edit = () => import("@/view/fileVerification/purchase-file-verification-edit")
//资审文件上传和核验
const information_file_verification_edit = () => import("@/view/fileVerification/information-file-verification-edit")
//无效公告编辑页面
const win_bid_invalid_notice_edit = () => import("@/view/winBidInvalid/notice-edit")
//无效公告核验列表
const verification_list = () => import("@/view/winBidInvalid/verification-list")
//采购人项目入场登记
const purchaser_project_list = () => import("@/view/tender/project/project-list")
//工作分派
const work_assign = () => import("@/view/tender/workassign/list")

//项目信息查看
const project_info_view_list = () => import("@/view/tender/projectInfoView/purchaser-project-info-list")

//授权委托书列表
const authorization_entrust_book_list = () => import("@/view/authorizationEntrustBook/book-list")
//授权委托书信息
const authorization_entrust_book_info = () => import("@/view/authorizationEntrustBook/book-info")
//奖惩数据拦截
const shfrlhjc_model = () => import('@/view/tender/shfrhjcModel/shfrhjcModel')

//G2交易系统（场地）
const sso = () => import("@/view/sso/sso")


//标后变更中标人申请列表
const win_bid_announcement_modify_list = () => import("@/view/winBidAnnouncementModifyExtend/win-bid-announcement-modify-list")
//标后变更中标人申请详细信息
const win_bid_announcement_modify_info = () => import("@/view/winBidAnnouncementModifyExtend/win-bid-announcement-modify-info")

//供应商 履约保函
const perforance_guarantee = () => import("@/view/contract/guarantee/supplier-guarantee/perforance-guarantee-list")
//招标人 履约保函
const tenderee_guarantee = () => import("@/view/contract/guarantee/tenderee-guarantee/tenderee-guarantee-list")
//供应商 发起支付申请
const pay_supplier_detail = () => import("@/view/bidding/pay/pay-supplier-edit")
const pay_supplier_view = () => import("@/view/bidding/pay/pay-supplier-view")
const pay_supplier_list = () => import("@/view/bidding/pay/pay-supplier-list")

const reaccreditation_conclusion_view_main = () => import("@/view/evaluation/reaccreditationconclusion/reaccreditation-conclusion-view")

const statistics_analysis_index = () => import("@/view/statistics-analysis/index")
const statistics_analysis_list = () => import("@/view/statistics-analysis/list")
const statistics_analysis_field_info = () => import("@/view/statistics-analysis/field-info")

const pay_apply = () =>import("@/view/pay/index")

const indexRouter = {
  path: '/index',
  name: 'index',
  component: index,
  children: [{
    path: 'ademo',
    name: 'ademo',
    component: ademo,
  },
  {
    path: 'nopower',
    name: 'nopower',
    component: no_power,
  },
  {
    path: 'todo-statistics',
    name: 'todo-statistics',
    component: todo_statistics
  },
  {
    path: 'work-assign',
    name: 'work-assign',
    component: work_assign
  },
  {
    path: 'qualification-audit-contest-pdf',
    name: 'qualification-audit-contest-pdf',
    component: qualification_audit_contest_pdf
  },
  {
    path: "filed-node-list",
    name: "filed-node-list",
    component: filed_node_list
  }, {
    path: "filed-type-list",
    name: "filed-type-list",
    component: filed_type_list
  },
  {
    path: 'purchase-demand-list',
    name: 'purchase-demand-list',
    component: purchase_demand_list
  },

  {
    path: 'purchase-demand-detail-jt-edit',
    name: 'purchase-demand-detail-jt-edit',
    component: purchase_demand_detail_jt_edit
  },
  {
    path: 'purchase-demand-detail-jt-view',
    name: 'purchase-demand-detail-jt-view',
    component: purchase_demand_detail_jt_view
  },
  {
    path: 'common-pdf',
    name: 'common-pdf',
    component: common_pdf
  },
  {
    path: 'project-list',
    name: 'project-list',
    component: project_list
  },
  {
    path: 'project-list-nodemand',
    name: 'project-list-nodemand',
    component: project_list_nodemand
  },
  {
    path: 'project-edit/:type',
    name: 'project-edit',
    component: project_edit
  },
  {
    path: 'project-approval-list',
    name: 'project-approval-list',
    component: project_approval_list
  },
  {
    path: 'project-approval',
    name: 'project-approval',
    component: project_approval
  },
  {
    path: 'selectpurchaser-name',
    name: 'selectpurchaser-name',
    component: selectpurchaser_name
  },
  {
    path: 'project-correction-list',
    name: 'project-correction-list',
    component: project_correction_list
  },
  {
    path: 'qualification-audit-correction-list',
    name: 'qualification-audit-correction-list',
    component: qualification_audit_correction_list
  },
  {
    path: 'project-overview',
    name: 'project-overview',
    component: project_overview
  },
  {
    path: 'project-overview-list',
    name: 'project-overview-list',
    component: project_overview_list
  },
  {
    path: 'project-correction-edit',
    name: 'project-correction-edit',
    component: project_correction_edit
  }, {
    path: 'qualification-audit-correction-edit',
    name: 'qualification-audit-correction-edit',
    component: qualification_audit_correction_edit
  },

  {
    path: 'purchase-demand-confirm-list',
    name: 'purchase-demand-confirm-list',
    component: purchase_demand_confirm_list
  },
  {
    path: 'purchase-demand-detail-approval-view',
    name: 'purchase-demand-detail-approval-view',
    component: purchase_demand_detail_approval_view
  },
  {
    path: 'procrement-file-approval-list',
    name: 'procrement-file-approval-list',
    component: procrement_file_approval_list
  },
  {
    path: 'purchase-file-approval-list',
    name: 'purchase-file-approval-list',
    component: purchase_file_approval_list
  },
  //投标邀请书及文件编制-核验列表
  {
    path: 'procrement-file-invitation-approval-list',
    name: 'procrement-file-invitation-approval-list',
    component: procrement_file_invitation_approval_list
  },
  //资审公告及文件核验列表
  {
    path: 'procrement-file-review-approval-list',
    name: 'procrement-file-review-approval-list',
    component: procrement_file_review_approval_list
  },
  {
    path: 'purchase-demand-notice-list',
    name: 'purchase-demand-notice-list',
    component: purchase_demand_notice_list
  },
  {
    path: 'purchase-demand-notice-edit',
    name: 'purchase-demand-notice-edit',
    component: purchase_demand_notice_edit
  },
  {
    path: 'purchase-demand-notice-view',
    name: 'purchase-demand-notice-view',
    component: purchase_demand_notice_view
  },
  {
    path: 'purchase-demand-notice-pdf',
    name: 'purchase-demand-notice-pdf',
    component: purchase_demand_notice_pdf
  },
  {
    path: 'notice-apply-list',
    name: 'notice-apply-list',
    component: notice_apply_list
  },
  {
    path: 'notice-apply-edit',
    name: 'notice-apply-edit',
    component: notice_apply_edit
  },
  {
    path: 'notice-apply-view',
    name: 'notice-apply-view',
    component: notice_apply_view
  },
  {
    path: 'purchase-demand-notice-approval-list',
    name: 'purchase-demand-notice-approval-list',
    component: purchase_demand_notice_approval_list
  },
  {
    path: 'purchase-demand-notice-approval-view',
    name: 'purchase-demand-notice-approval-view',
    component: purchase_demand_notice_approval_view
  },
  {
    path: 'procrement-file-approval-view',
    name: 'procrement-file-approval-view',
    component: procrement_file_approval_view
  },
  {
    path: 'procrement-file-approval-contest-view',
    name: 'procrement-file-approval-contest-view',
    component: procrement_file_approval_contest_view
  },
  {
    path: 'procrement-notice-contest-invitation-view',
    name: 'procrement-notice-contest-invitation-view',
    component: procrement_notice_contest_invitation_view
  },
  {
    path: 'procrement-file-detail-inquiry-view',
    name: 'procrement-file-detail-inquiry-view',
    component: procrement_file_approval_inquiry_view
  },
  {
    path: 'procrement-file-detail-inquiry-invitation-view',
    name: 'procrement-file-detail-inquiry-invitation-view',
    component: procrement_file_approval_inquiry_invitation_view
  },
  {
    path: 'procrement-file-approval-competition-view',
    name: 'procrement-file-approval-competition-view',
    component: procrement_file_approval_competition_view
  },
  {
    path: 'procrement-file-approval-notcarry-view',
    name: 'procrement-file-approval-notcarry-view',
    component: procrement_file_approval_notcarry_view
  },

  {
    path: 'procrement-file-detail-competition-intitation-view',
    name: 'procrement-file-detail-competition-intitation-view',
    component: procrement_file_detail_competition_intitation_view
  },
  {
    path: 'procrement-notice-invitation-pretrial-view',
    name: 'procrement-notice-invitation-pretrial-view',
    component: procrement_notice_invitation_pretrial_view
  },
  {
    path: 'procrement-notice-invitation-two-envelope-view',
    name: 'procrement-notice-invitation-two-envelope-view',
    component: procrement_notice_invitation_two_envelope_view
  },
  {
    path: 'bid-invitation-pdf',
    name: 'bid-invitation-pdf',
    component: bid_invitation_pdf
  },
  {
    path: 'procrement-file-approval-onesource-view',
    name: 'procrement-file-approval-onesource-view',
    component: procrement_file_approval_onesource_view
  },
  {
    path: 'carry-out-notice-list',
    name: 'carry-out-notice-list',
    component: carry_out_notice_list,
  },
  {
    path: 'carry-out-notice-edit/:type',
    name: 'carry-out-notice-edit',
    component: carry_out_notice_edit
  },
  {
    path: 'selectpurchaser-agency-name',
    name: 'selectpurchaser-agency-name',
    component: selectpurchaser_agency_name
  },
  {
    path: 'agency-agreement-edit',
    name: 'agency-agreement-edit',
    component: agency_agreement_edit
  },
  {
    path: 'agency-agreement-list',
    name: 'agency-agreement-list',
    component: agency_agreement_list
  },
  {
      path: 'agency-agreement-list-jzr',
      name: 'agency-agreement-list-jzr',
      component: agency_agreement_list_jzr
  },
  {
    path: 'agency-agreement-list-agency',
    name: 'agency-agreement-list-agency',
    component: agency_agreement_list_agency
  },
  {
    path: 'agency-agreement-list-agency-edit',
    name: 'agency-agreement-list-agency-edit',
    component: agency_agreement_list_agency_edit
  },
  {
    path: 'agency-agreement-list-agency-check',
    name: 'agency-agreement-list-agency-check',
    component: agency_agreement_list_agency_check
  },
  {
    path: 'agency-agreement-list-check',
    name: 'agency-agreement-list-check',
    component: agency_agreement_list_check
  },
  {
    path: 'enpert-application-list',
    name: 'enpert-application-list',
    component: enpert_application_list
  },
  {
    path: 'enpert-application-edit',
    name: 'enpert-application-edit',
    component: enpert_application_edit
  },
  {
    path: 'enpert-application-view',
    name: 'enpert-application-view',
    component: enpert_application_view
  },
  {
    path: 'agency-agreement-pdf',
    name: 'agency-agreement-pdf',
    component: agency_agreement_pdf
  },
  {
    path: 'carry-out-notice-acceptance-list',
    name: 'carry-out-notice-acceptance-list',
    component: carry_out_notice_acceptance_list
  },
  {
    path: 'carry-out-notice-acceptance-view',
    name: 'carry-out-notice-acceptance-view',
    component: carry_out_notice_acceptance_view
  },
  {
    path: 'agency-agreement-acceptance-pdf',
    name: 'agency-agreement-acceptance-pdf',
    component: agency_agreement_acceptance_pdf
  },
  {
    path: 'carry-out-notice-assign-list',
    name: 'carry-out-notice-assign-list',
    component: carry_out_notice_assign_list
  },
  {
    path: 'carry-out-notice-de-assign-list',
    name: 'carry-out-notice-de-assign-list',
    component: carry_out_notice_de_assign_list
  },
  {
    path: 'distribution-list',
    name: 'distribution-list',
    component: distribution_list
  },
  {
    path: 'distribution-list-principal',
    name: 'distribution-list-principal',
    component: distribution_list //项目负责人分配
  },
  {
    path: 'distribution-list-principal-approval',
    name: 'distribution-list-principal-approval',
    component: distribution_list //核验
  },
  {
    path: 'distribution-list-principal-confirm',
    name: 'distribution-list-principal-confirm',
    component: distribution_list_confirm //项目负责人分配确认
  },
  {
    path: 'distribution-project-info',
    name: 'distribution-project-info',
    component: distribution_project_info
  },
  {
    path: 'carry-out-notice-read-list',
    name: 'carry-out-notice-read-list',
    component: carry_out_notice_read_list
  },
  {
    path: 'carry-out-notice-assign-confirm-list',
    name: 'carry-out-notice-assign-confirm-list',
    component: carry_out_notice_assign_confirm_list
  },
  {
    path: 'carry-out-notice-assign-view',
    name: 'carry-out-notice-assign-view',
    component: carry_out_notice_assign_view
  },
  {
    path: 'carry-out-notice-de-assign-view',
    name: 'carry-out-notice-de-assign-view',
    component: carry_out_notice_de_assign_view
  },
  /**标中任务分派 */
  {
    path: 'project-assign-list',
    name: 'project-assign-list',
    component: project_assign_list
  },
  /**标中任务分派确认 */
  {
    path: 'project-assign-confirm-list',
    name: 'project-assign-confirm-list',
    component: project_assign_confirm_list
  },
  {
    path: 'bid-document-edit',
    name: 'bid-document-edit',
    component: bid_document_edit
  },
  {
    path: 'bid-unitdocument-edit',
    name: 'bid-unitdocument-edit',
    component: bid_unitdocument_edit
  },
  {
    path: 'bid-document-list',
    name: 'bid-document-list',
    component: bid_document_list
  },
  {
    path: 'bid-document-view',
    name: 'bid-document-view',
    component: bid_document_view
  },
  {
    path: 'bid-unitdocument-view',
    name: 'bid-unitdocument-view',
    component: bid_unitdocument_view
  },
  {
    path: 'bid-document-registerform-view',
    name: 'bid-document-registerform-view',
    component: bid_document_registerform_view
  },
  {
    path: 'bid-joint-list',
    name: 'bid-joint-list',
    component: bid_joint_list
  },
  {
    path: 'procrement-notice-reserve',
    name: 'procrement-notice-reserve',
    component: procrement_notice_reserve
  },

  {
    path: 'register-manage-list',
    name: 'register-manage-list',
    component: register_manage_list
  },
  {
    path: 'register-manage-view',
    name: 'register-manage-view',
    component: register_manage_view
  },

  {
    path: 'contract-publicity-verification-approve',
    name: 'contract-publicity-verification-approve',
    component: contract_publicity_verification_approve
  },
  {
    path: 'contract-publicity-verification-list',
    name: 'contract-publicity-verification-list',
    component: contract_publicity_verification_list
  },
  {
    path: 'contract-publicity-verification-view',
    name: 'contract-publicity-verification-view',
    component: contract_publicity_verification_view
  },
  {
    path: 'contract-publicity-verification-pdf',
    name: 'contract-publicity-verification-pdf',
    component: contract_publicity_verification_pdf
  },
  {
    path: 'modify-notice-approve-list',
    name: 'modify-notice-approve-list',
    component: modify_notice_approve_list
  }, {
    path: 'qualification-audit-modify-notice-approve-list',
    name: 'qualification-audit-modify-notice-approve-list',
    component: qualification_audit_modify_notice_approve_list
  },
  {
    path: 'modify-notice-approve-view',
    name: 'modify-notice-approve-view',
    component: modify_notice_approve_view
  },
  {
    path: 'qualification-audit-modify-notice-approve-view',
    name: 'qualification-audit-modify-notice-approve-view',
    component: qualification_audit_modify_notice_approve_view
  },
  {
    path: 'purchaser-project-management-list',
    name: 'purchaser-project-management-list',
    component: purchaser_project_management_list
  },
  {
    path: 'shfrlhjc-model',
    name: 'shfrlhjc-model',
    component: shfrlhjc_model
  },
  {
    path: 'confirm-win-bidder-edit',
    name: 'confirm-win-bidder-edit',
    component: confirm_win_bidder_edit
  },
  {
    path: 'confirm-win-bidder-list',
    name: 'confirm-win-bidder-list',
    component: confirm_win_bidder_list
  },
  {
    path: 'procrement-notice-pdf',
    name: 'procrement-notice-pdf',
    component: procrement_notice_pdf
  },

  {
    path: 'win-bid-announcement-approve-edit',
    name: 'win-bid-announcement-approve-edit',
    component: win_bid_announcement_approve_edit
  },
  {
    path: 'win-bid-announcement-approve-list',
    name: 'win-bid-announcement-approve-list',
    component: win_bid_announcement_approve_list
  },
  {
    path: 'evaluation-bid-result-approve-edit',
    name: 'evaluation-bid-result-approve-edit',
    component: evaluation_bid_result_approve_edit
  },
  {
    path: 'evaluation-bid-result-approve-list',
    name: 'evaluation-bid-result-approve-list',
    component: evaluation_bid_result_approve_list
  },
  {
    path: 'question-list',
    name: 'question-list',
    component: question_list
  },
  {
    path: 'question-edit',
    name: 'question-edit',
    component: question_edit
  },
  {
    path: 'question-view',
    name: 'question-view',
    component: question_view
  },
  {
    path: 'question-other',
    name: 'question-other',
    component: question_other
  },
  {
    path: 'question-release',
    name: 'question-release',
    component: question_release
  },
  {
    path: 'answer-list',
    name: 'answer-list',
    component: answer_list
  },
      {
          path: 'answer-reply-approval-list',
          name: 'answer-reply-approval-list',
          component: answer_reply_approval_list
      },
  {
    path: 'answer-reply',
    name: 'answer-reply',
    component: answer_reply
  },
  {
    path: 'answer-receipt',
    name: 'answer-receipt',
    component: answer_receipt
  },
  {
    path: 'answer-detail',
    name: 'answer-detail',
    component: answer_detail
  },
  {
      path: 'answer-offline-edit',
      name: 'answer-offline-edit',
      component: answer_offline_edit
  },
  {
    path: 'answer-publicity',
    name: 'answer-publicity',
    component: answer_publicity
  },
  {
    path: 'answer-publicity-edit',
    name: 'answer-publicity-edit',
    component: publicity_edit
  }, {
    path: 'answer-publicity-view',
    name: 'answer-publicity-view',
    component: publicity_view
  },
  {
    path: 'answer-publicity-check',
    name: 'answer-publicity-check',
    component: publicity_check
  },
  {
    path: "answer-publicity-approve",
    name: "answer-publicity-approve",
    component: publicity_approve
  },
  {
    path: 'answer-query',
    name: 'answer-query',
    component: answer_query,
  },
  {
    path: 'answer-query-edit',
    name: 'answer-query-edit',
    component: answer_query_edit,
  },
  {
    path: 'answer-query-view',
    name: 'answer-query-view',
    component: answer_query_view,
  },
  {
    path: 'answer-query-release',
    name: 'answer-query-release',
    component: answer_query_release
  },
  {
    path: 'answer-reply-list',
    name: 'answer-reply-list',
    component: answer_reply_list,
  },
  {
    path: 'answer-reply-edit',
    name: 'answer-reply-edit',
    component: answer_reply_edit,
  },
  {
    path: 'answer-reply-view',
    name: 'answer-reply-view',
    component: answer_reply_view,
  },
  {
    path: 'answer-query-reply',
    name: 'answer-query-reply',
    component: answer_query_reply
  },
  {
      path: 'answer-query-check',
      name: 'answer-query-check',
      component: answer_query_check
    },
    {
      path: "pay-apply",
      name: "pay-apply",
      component:pay_apply
  },
  {
      path: 'answer-query-approve',
      name: 'answer-query-approve',
      component: answer_query_approve
  },
  {
      path: 'answer-query-approve-release',
      name: 'answer-query-approve-release',
      component: answer_query_approve_release
  },
  {
    path: 'win-bid-notice-modify-approve-list',
    name: 'win-bid-notice-modify-approve-list',
    component: win_bid_notice_modify_approve_list
  },
  {
    path: 'project-approve-assign-list',
    name: 'project-approve-assign-list',
    component: project_approve_assign_list
  },
  {
    path: 'win-bid-notice-modify-approve-view',
    name: 'win-bid-notice-modify-approve-view',
    component: win_bid_notice_modify_approve_view
  }, {
    path: 'win-bid-notice-modify-approval-view-pdf',
    name: 'win-bid-notice-modify-approval-view-pdf',
    component: win_bid_notice_modify_approval_view_pdf
  }, {
    path: 'project-filing-list',
    name: 'project-filing-list',
    component: project_filing_list
  },
  {
    path: 'project-filing-edit',
    name: 'project-filing-edit',
    component: project_filing_edit
  },
  {
    path: 'project-filing-view',
    name: 'project-filing-view',
    component: project_filing_view
  },
  {
    path: 'project-filing-jgbmshow',
    name: 'project-filing-jgbmshow',
    component: project_filing_jgbmshow
  },
  {
    path: 'project-filing-cgrshow',
    name: 'project-filing-cgrshow',
    component: project_filing_cgrshow
  },

  /**项目异常处理开始 */
  {
    path: 'project-stop-list',
    name: 'project-stop-list',
    component: project_stop_list
  },
  {
    path: 'purchaser-project-stop-list',
    name: 'purchaser-project-stop-list',
    component: purchaser_project_stop_list
  }, {
    path: 'manager-project-stop-approval-list',
    name: 'manager-project-stop-approval-list',
    component: manager_project_stop_approval_list
  }, {
    path: 'manager-project-stop-approval-edit',
    name: 'manager-project-stop-approval-edit',
    component: manager_project_stop_approval_edit
  },
  {
    path: 'purchaser-project-stop-edit',
    name: 'purchaser-project-stop-edit',
    component: purchaser_project_stop_edit
  },
  {
    path: 'project-stop-edit',
    name: 'project-stop-edit',
    component: project_stop_edit
  },
  {
    path: 'project-stop-view',
    name: 'project-stop-view',
    component: project_stop_view
  },
  {
    path: 'project-stop-approval-view',
    name: 'project-stop-approval-view',
    component: project_stop_approval_view
  },
  {
    path: 'project-stop-approval-list',
    name: 'project-stop-approval-list',
    component: project_stop_approval_list
  },
  {
    path: 'project-stop-approval-edit',
    name: 'project-stop-approval-edit',
    component: project_stop_approval_edit
  },
  {
    path: 'nullifield-bid-approval-list',
    name: 'nullifield-bid-approval-list',
    component: nullifield_bid_approval_list
  },
  {
    path: 'nullifield-bid-approval-edit',
    name: 'nullifield-bid-approval-edit',
    component: nullifield_bid_approval_edit
  },
  {
    path: 'nullifield-bid-approval-view',
    name: 'nullifield-bid-approval-view',
    component: nullifield_bid_approval_view
  },
  {
    path: 'project-pause-resumed-list',
    name: 'project-pause-resumed-list',
    component: project_pause_resumed_list
  }, {
    path: 'purchaser-project-pause-resumed-list',
    name: 'purchaser-project-pause-resumed-list',
    component: purchaser_project_pause_resumed_list
  }, {
    path: 'purchaser-project-pause-edit',
    name: 'purchaser-project-pause-edit',
    component: purchaser_project_pause_edit
  },
  //保证金管理
  {
    path: 'return-guarantee-list',
    name: 'return-guarantee-list',
    component: return_guarantee_list
  },
  {
    path: 'return-guarantee-edit',
    name: 'return-guarantee-edit',
    component: return_guarantee_info
  },
  {
    path: 'return-guarantee-view',
    name: 'return-guarantee-view',
    component: return_guarantee_info
  },
  {
    path: 'check-return-list',
    name: 'check-return-list',
    component: check_return_list
  },
  {
    path: 'check-return-view',
    name: 'check-return-view',
    component: return_guarantee_info
  },
  {
    path: 'return-guarantee-approval-list',
    name: 'return-guarantee-approval-list',
    component: return_guarantee_approval_list
  },
  {
    path: 'return-guarantee-approval-view',
    name: 'return-guarantee-approval-view',
    component: return_guarantee_info
  },
  //保证金管理
  {
    path: 'project-pause-edit',
    name: 'project-pause-edit',
    component: project_pause_edit
  },
  {
    path: 'project-pause-pdf',
    name: 'project-pause-pdf',
    component: project_pause_pdf
  }, {
    path: 'purchaser-project-pause-pdf',
    name: 'purchaser-project-pause-pdf',
    component: purchaser_project_pause_pdf
  },
  {
    path: 'project-resumed-pdf',
    name: 'project-resumed-pdf',
    component: project_resumed_pdf
  },
  {
    path: 'project-resumed-edit',
    name: 'project-resumed-edit',
    component: project_resumed_edit
  }, {
    path: 'purchaser-project-resumed-pdf',
    name: 'purchaser-project-resumed-pdf',
    component: purchaser_project_resumed_pdf
  },
  {
    path: 'purchaser-project-resumed-edit',
    name: 'purchaser-project-resumed-edit',
    component: purchaser_project_resumed_edit
  },
  {
    path: 'project-pause-resumed-approval-list',
    name: 'project-pause-resumed-approval-list',
    component: project_pause_resumed_approval_list
  }, {
    path: 'manager-project-pause-resumed-approval-list',
    name: 'manager-project-pause-resumed-approval-list',
    component: manager_project_pause_resumed_approval_list
  },
  //保函索赔申请
  {
    path: 'guarantee-letter-claim-list',
    name: 'guarantee-letter-claim-list',
    component: guarantee_letter_claim_list
  },
  {
    path: 'guarantee-letter-claim-info/:type',
    name: 'guarantee-letter-claim-info',
    component: guarantee_letter_claim_info
  },
  //保函索赔申请核验
  {
    path: 'guarantee-letter-claim-approval',
    name: 'guarantee-letter-claim-approval',
    component: guarantee_letter_claim_approval
  },
  {
    path: 'project-pause-approval-edit',
    name: 'project-pause-approval-edit',
    component: project_pause_approval_edit
  }, {
    path: 'manager-project-pause-approval-edit',
    name: 'manager-project-pause-approval-edit',
    component: manager_project_pause_approval_edit
  },
  {
    path: 'project-pause-approval-pdf',
    name: 'project-pause-approval-pdf',
    component: project_pause_approval_pdf
  },
  {
    path: 'project-resumed-approval-pdf',
    name: 'project-resumed-approval-pdf',
    component: project_resumed_approval_pdf
  },
  {
    path: 'project-resumed-approval-edit',
    name: 'project-resumed-approval-edit',
    component: project_resumed_approval_edit
  }, {
    path: 'manager-project-resumed-approval-pdf',
    name: 'manager-project-resumed-approval-pdf',
    component: manager_project_resumed_approval_pdf
  },
  {
    path: 'manager-project-resumed-approval-edit',
    name: 'manager-project-resumed-approval-edit',
    component: manager_project_resumed_approval_edit
  },
  /**项目异常处理结束 */
  {
    path: 'reaccreditation-apply-approval-list',
    name: 'reaccreditation-apply-approval-list',
    component: reaccreditation_apply_approval_list
  },
  {
    path: 'reaccreditation-apply-approval-view',
    name: 'reaccreditation-apply-approval-view',
    component: reaccreditation_apply_approval_view
  },
  {
    path: 'purchase-demand-query-list',
    name: 'purchase-demand-query-list',
    component: purchase_demand_query_list
  },
  {
    path: 'purchase-demand-query-edit',
    name: 'purchase-demand-query-edit',
    component: purchase_demand_query_edit
  },
  {
    path: 'purchase-demand-query-view',
    name: 'purchase-demand-query-view',
    component: purchase_demand_query_view
  },
  {
    path: 'recommended-supplier-list',
    name: 'recommended-supplier-list',
    component: recommended_supplier_list
  },
  {
    path: 'recommended-supplier-edit',
    name: 'recommended-supplier-edit',
    component: recommended_supplier_edit
  },
  {
    path: 'recommended-supplier-view',
    name: 'recommended-supplier-view',
    component: recommended_supplier_view
  },
  {
    path: 'change-judge-application-approve-edit',
    name: 'change-judge-application-approve-edit',
    component: change_judge_application_approve_edit
  },
  {
    path: 'change-judge-application-approve-list',
    name: 'change-judge-application-approve-list',
    component: change_judge_application_approve_list
  },
  {
    path: 'change-purchaser-mode-approve-edit',
    name: 'change-purchaser-mode-approve-edit',
    component: change_purchaser_mode_approve_edit
  },
  {
    path: 'change-purchaser-mode-approve-list',
    name: 'change-purchaser-mode-approve-list',
    component: change_purchaser_mode_approve_list
  },
  {
    path: 'purchase-demand-answer-list',
    name: 'purchase-demand-answer-list',
    component: purchase_demand_answer_list
  },
  {
    path: 'purchase-demand-answer-enterprise-list',
    name: 'purchase-demand-answer-enterprise-list',
    component: purchase_demand_answer_enterprise_list
  },
  {
    path: 'survey-result-record-cgr-list',
    name: 'survey-result-record-cgr-list',
    component: survey_result_record_cgr_list
  },
  {
    path: 'survey-result-record-cgr-edit',
    name: 'survey-result-record-cgr-edit',
    component: survey_result_record_cgr_edit
  },
  {
    path: 'survey-result-record-cgr-view',
    name: 'survey-result-record-cgr-view',
    component: survey_result_record_cgr_view
  },
  {
    path: 'implementation-list',
    name: 'implementation-list',
    component: implementation_list
  },
  {
    path: 'implementation-role-list',
    name: 'implementation-role-list',
    component: implementation_role_list
  },
  {
    path: 'implementation-role-view',
    name: 'implementation-role-view',
    component: implementation_role_view
  },
  {
    path: 'implementation-edit/:type',
    name: 'implementation-edit',
    component: implementation_edit
  },
  {
    path: 'implementation-view',
    name: 'implementation-view',
    component: implementation_view
  },
  {
    path: 'win-bid-notice-modify-release',
    name: 'win-bid-notice-modify-release',
    component: win_bid_notice_modify_release
  },
  {
    path: 'win-bid-announcement-release',
    name: 'win-bid-announcement-release',
    component: win_bid_announcement_release
  },
  {
    path: 'receipt-record',
    name: 'receipt-record',
    component: receipt_record
  },
  {
    path: 'complaint-edit',
    name: 'complaint-edit',
    component: complaint_edit
  },
  {
    path: 'complaint-list',
    name: 'complaint-list',
    component: complaint_list
  },
  {
    path: 'complaint-view',
    name: 'complaint-view',
    component: complaint_view
  },
  {
    path: 'complaint-answer-edit',
    name: 'complaint-answer-edit',
    component: complaint_answer_edit
  },
  {
    path: 'complaint-answer-list',
    name: 'complaint-answer-list',
    component: complaint_answer_list
  },
  {
    path: 'complaint-answer-view',
    name: 'complaint-answer-view',
    component: complaint_answer_view
  },
  {
    path: 'complaint-online-edit',
    name: 'complaint-online-edit',
    component: complaint_online_edit
  },
  {
    path: 'complaint-online-list',
    name: 'complaint-online-list',
    component: complaint_online_list
  },
  {
    path: 'complaint-online-view',
    name: 'complaint-online-view',
    component: complaint_online_view
  },
  {
    path: 'contract-publicity-cgr-list',
    name: 'contract-publicity-cgr-list',
    component: contract_publicity_cgr_list
  },
  {
    path: 'contract-publicity-cgr-edit',
    name: 'contract-publicity-cgr-edit',
    component: contract_publicity_cgr_edit
  },
  {
    path: 'contract-publicity-cgr-view',
    name: 'contract-publicity-cgr-view',
    component: contract_publicity_cgr_view
  }, {
    path: 'contract-publicity-cgr-pdf',
    name: 'contract-publicity-cgr-pdf',
    component: contract_publicity_cgr_pdf
  }, {
    path: 'contract-publicity-pdfcgr',
    name: 'contract-publicity-pdfcgr',
    component: contract_publicity_pdfcgr
  }, {
    path: 'project-filed-list',
    name: 'project-filed-list',
    component: project_filed_list
  }, {
    path: 'project-filed-list-all',
    name: 'project-filed-list-all',
    component: project_filed_list_all
  }, {
    path: 'project-filed-view-index',
    name: 'project-filed-view-index',
    component: project_filed_view_index
  },
  /**公告抽取 */
  {
    path: 'notice-modify-notice-pdf',
    name: 'notice-modify-notice-pdf',
    component: notice_modify_notice_pdf
  },
  {
    path: 'notice-win-bid-announcement-release',
    name: 'notice-win-bid-announcement-release',
    component: notice_win_bid_announcement_release
  },
  {
    path: 'notice-win-bid-notice-modify-pdf',
    name: 'notice-win-bid-notice-modify-pdf',
    component: notice_win_bid_notice_modify_pdf
  },
  {
    path: 'notice-win-bid-notice-modify-pdf',
    name: 'notice-win-bid-notice-modify-pdf',
    component: notice_win_bid_notice_modify_pdf
  },
  {
    path: 'single-source-notice-approval-list',
    name: 'single-source-notice-approval-list',
    component: single_source_notice_approval_list
  },
  {
    path: 'single-source-notice-approval-view',
    name: 'single-source-notice-approval-view',
    component: single_source_notice_approval_view
  },
  {
    path: 'single-source-notice-approval-apply-view',
    name: 'single-source-notice-approval-apply-view',
    component: single_source_notice_approval_apply_view
  },
  {
    path: 'qualification-audit-approval-list',
    name: 'qualification-audit-approval-list',
    component: qualification_audit_approval_list
  },
  {
    path: 'qualification-audit-approval-view',
    name: 'qualification-audit-approval-view',
    component: qualification_audit_approval_view
  },
  //邀请书及文件编制-核验
  {
    path: 'procrement-file-detail-invitation-bid-notice/:type',
    name: 'procrement-file-detail-invitation-bid-notice',
    component: procrement_file_detail_invitation_bid_notice
  },
  {
    path: 'procrement-file-detail-invitation-bid-company/:type',
    name: 'procrement-file-detail-invitation-bid-company',
    component: procrement_file_detail_invitation_bid_company
  },
  {
    path: 'procrement-file-detail-invitation-bid-file/:type',
    name: 'procrement-file-detail-invitation-bid-file',
    component: procrement_file_detail_invitation_bid_file
  },
  {
    path: 'procrement-file-detail-invitation-competition-notice/:type',
    name: 'procrement-file-detail-invitation-competition-notice',
    component: procrement_file_detail_invitation_competition_notice
  },
  {
    path: 'procrement-file-detail-invitation-competition-company/:type',
    name: 'procrement-file-detail-invitation-competition-company',
    component: procrement_file_detail_invitation_competition_company
  },
  {
    path: 'procrement-file-detail-invitation-competition-file/:type',
    name: 'procrement-file-detail-invitation-competition-file',
    component: procrement_file_detail_invitation_competition_file
  },
  {
    path: 'procrement-file-detail-invitation-inquiry-notice/:type',
    name: 'procrement-file-detail-invitation-inquiry-notice',
    component: procrement_file_detail_invitation_inquiry_notice
  },
  {
    path: 'procrement-file-detail-invitation-inquiry-company/:type',
    name: 'procrement-file-detail-invitation-inquiry-company',
    component: procrement_file_detail_invitation_inquiry_company
  },
  {
    path: 'procrement-file-detail-invitation-inquiry-file/:type',
    name: 'procrement-file-detail-invitation-inquiry-file',
    component: procrement_file_detail_invitation_inquiry_file
  },
  {
    path: 'procrement-file-detail-invitation-negotiation-notice/:type',
    name: 'procrement-file-detail-invitation-negotiation-notice',
    component: procrement_file_detail_invitation_negotiation_notice
  },
  {
    path: 'procrement-file-detail-invitation-negotiation-company/:type',
    name: 'procrement-file-detail-invitation-negotiation-company',
    component: procrement_file_detail_invitation_negotiation_company
  },
  {
    path: 'procrement-file-detail-invitation-negotiation-file/:type',
    name: 'procrement-file-detail-invitation-negotiation-file',
    component: procrement_file_detail_invitation_negotiation_file
  },
  {
    path: 'procrement-file-detail-invitation-onesource-notice/:type',
    name: 'procrement-file-detail-invitation-onesource-notice',
    component: procrement_file_detail_invitation_onesource_notice
  },
  {
    path: 'procrement-file-detail-invitation-onesource-company/:type',
    name: 'procrement-file-detail-invitation-onesource-company',
    component: procrement_file_detail_invitation_onesource_company
  },
  {
    path: 'procrement-file-detail-invitation-onesource-file/:type',
    name: 'procrement-file-detail-invitation-onesource-file',
    component: procrement_file_detail_invitation_onesource_file
  },
  {
    path: 'procrement-file-detail-invitation-pretrial-notice/:type',
    name: 'procrement-file-detail-invitation-pretrial-notice',
    component: procrement_file_detail_invitation_pretrial_notice
  },
  {
    path: 'procrement-file-detail-invitation-pretrial-company/:type',
    name: 'procrement-file-detail-invitation-pretrial-company',
    component: procrement_file_detail_invitation_pretrial_company
  },
  {
    path: 'procrement-file-detail-invitation-pretrial-file/:type',
    name: 'procrement-file-detail-invitation-pretrial-file',
    component: procrement_file_detail_invitation_pretrial_file
  },
  //公告及文件-核验
  {
    path: 'procrement-file-detail-notice/:type',
    name: 'procrement-file-detail-notice',
    component: procrement_file_detail_notice
  },
  {
    path: 'procrement-file-detail-file/:type',
    name: 'procrement-file-detail-file',
    component: procrement_file_detail_file
  },
  {
    path: 'procrement-file-detail-competition-notice/:type',
    name: 'procrement-file-detail-competition-notice',
    component: procrement_file_detail_competition_notice
  },
  {
    path: 'procrement-file-detail-competition-file/:type',
    name: 'procrement-file-detail-competition-file',
    component: procrement_file_detail_competition_file
  },
  {
    path: 'procrement-file-detail-negotiation-notice/:type',
    name: 'procrement-file-detail-negotiation-notice',
    component: procrement_file_detail_negotiation_notice
  },
  {
    path: 'procrement-file-detail-onesource-notice/:type',
    name: 'procrement-file-detail-onesource-notice',
    component: procrement_file_detail_onesource_notice
  },
  {
    path: 'procrement-file-detail-inquiry-notice/:type',
    name: 'procrement-file-detail-inquiry-notice',
    component: procrement_file_detail_inquiry_notice
  },
  {
    path: 'procrement-file-detail-negotiation-file/:type',
    name: 'procrement-file-detail-negotiation-file',
    component: procrement_file_detail_negotiation_file
  },
  {
    path: 'procrement-file-detail-onesource-file/:type',
    name: 'procrement-file-detail-onesource-file',
    component: procrement_file_detail_onesource_file
  },
  {
    path: 'procrement-file-detail-inquiry-file/:type',
    name: 'procrement-file-detail-inquiry-file',
    component: procrement_file_detail_inquiry_file
  },
  //资审公告及文件
  {
    path: 'procrement-file-detail-review-notice/:type',
    name: 'procrement-file-detail-review-notice',
    component: procrement_file_detail_review_notice
  },
  {
    path: 'procrement-file-detail-review-file/:type',
    name: 'procrement-file-detail-review-file',
    component: procrement_file_detail_review_file
  },
  //查看中标通知书
  {
    path: 'bid-notice-list',
    name: 'bid-notice-list',
    component: bid_notice_list
  },

  //交易情况统计
  {
    path: 'transactionstatus-edit',
    name: 'transactionstatus-edit',
    component: transactionstatus_edit
  },
  {
    path: 'transactionstatus-list',
    name: 'transactionstatus-list',
    component: transactionstatus_list
  },
  //场地
  {
    path: 'venue-book-approval',
    component: venue_book,
    children: [{
      path: '/',
      component: venue_book_verification
    },
    {
      path: ':type/:model',
      component: venue_book_info
    }
    ]
  },
  {
    path: 'venue-book-review-approval',
    component: venue_book_review,
    children: [{
      path: '/',
      component: venue_book_review_verification
    },
    {
      path: ':type/:model',
      component: venue_book_review_info
    }
    ]
  },
  {
    path: 'enroll-view-leader-list',
    name: 'enroll-view-leader-list',
    component: enroll_view_leader_list
  },
  {
    path: 'enroll-view-list',
    name: 'enroll-view-list',
    component: enroll_view_list
  },
  {
    path: 'modify-notice-pdf',
    name: 'modify-notice-pdf',
    component: modify_notice_pdf
  },
  {
    path: 'qualification-audit-notice-modify-pdf',
    name: 'qualification-audit-notice-modify-pdf',
    component: qualification_audit_notice_modify_pdf
  },
  {
    path: 'nullifield-bid-pdf-view',
    name: 'nullifield-bid-pdf-view',
    component: nullifield_bid_pdf_view
  },
  {
    path: "sign-contracts-online",
    name: "sign-contracts-online",
    component: sign_contracts_online,
    redirect: "sign-contracts-online/organization",
    children:
      [
        {
          path: 'organization',
          name: 'organization',
          component: sign_contracts_online_organization
        },
        {
          path: 'organization-view',
          name: 'organization-view',
          component: sign_contracts_online_organization_view
        },
        {
          path: 'organization-edit',
          name: 'organization-edit',
          component: sign_contracts_online_organization_edit
        },
        {
          path: 'organization-pdf',
          name: 'organization-pdf',
          component: sign_contracts_online_organization_pdf
        },
        {
          path: 'find',
          name: "find",
          component: sign_contracts_online_see
        },
        {
          path: 'find-view',
          name: 'find-view',
          component: sign_contracts_online_see_view
        },
        {
          path: 'sure',
          name: 'sure',
          component: sign_contracts_online_sure
        },
        {
          path: 'sure-view',
          name: 'sure-view',
          component: sign_contracts_online_sure_view
        },

      ]
  },


  {
    path: 'organization-check',
    name: 'organization-check',
    component: sign_contracts_online_check
  },
  {
    path: 'organization-check-view',
    name: 'organization-check-view',
    component: sign_contracts_online_check_view
  },
  {
    path: "evaluate-purchaser",
    name: "evaluate-purchaser",
    component: evaluate_purchaser_list
  },
  {
    path: "evaluate-purchaser-edit",
    name: "evaluate-purchaser-edit",
    component: evaluate_purchaser_list_edit
  },
  {
    path: "evaluate-purchaser-view",
    name: "evaluate-purchaser-view",
    component: evaluate_purchaser_list_view
  },
  {
    path: "evaluate-suppliers",
    name: "evaluate-suppliers",
    component: evaluate_suppliers_list
  },
  {
    path: "evaluate-suppliers-edit",
    name: "evaluate-suppliers-edit",
    component: evaluate_suppliers_list_edit
  },
  {
    path: "evaluate-suppliers-view",
    name: "evaluate-suppliers-view",
    component: evaluate_suppliers_list_view
  },
  {
    path: "interested-parties",
    name: "interested-parties",
    component: interested_parties_list
  },
  {
    path: "interested-parties-view",
    name: "interested-parties-view",
    component: interested_parties_view
  },
  {
    path: 'purchase-file-verification-list',
    name: 'purchase-file-verification-list',
    component: purchase_file_verification_list
  },
  {
    path: 'information-file-verification-list',
    name: 'information-file-verification-list',
    component: information_file_verification_list
  },
  {
    path: 'purchase-file-verification-edit/:type',
    name: 'purchase-file-verification-edit',
    component: purchase_file_verification_edit
  },
  {
    path: 'information-file-verification-edit/:type',
    name: 'information-file-verification-edit',
    component: information_file_verification_edit
  },
  {
    path: 'win-bid-invalid-notice-edit',
    name: 'win-bid-invalid-notice-edit',
    component: win_bid_invalid_notice_edit
  }, {
    path: 'verification-list',
    name: 'verification-list',
    component: verification_list
  },//采购人项目入场
  {
    path: 'purchaser-project-list',
    name: 'purchaser-project-list',
    component: purchaser_project_list
  },
  {
    path: 'project-info-view-list',
    name: 'project-info-view-list',
    component: project_info_view_list
  },
  {
    path: 'authorization-entrust-book-list',
    name: 'authorization-entrust-book-list',
    component: authorization_entrust_book_list
  },
  {
    path: 'authorization-entrust-book-info',
    name: 'authorization-entrust-book-info',
    component: authorization_entrust_book_info
  },
  {
    path: 'sso',
    name: 'sso',
    component: sso
  },
   {
    path: 'win-bid-announcement-modify-list',
    name: 'win-bid-announcement-modify-list',
    component: win_bid_announcement_modify_list
  },
  {
    path: 'win-bid-announcement-modify-info',
    name: 'win-bid-announcement-modify-info',
    component: win_bid_announcement_modify_info
  },
  {
    path: "perforance-guarantee",
    name: 'perforance-guarantee',
    component: perforance_guarantee
  },
  {
    path: "tenderee-guarantee",
    name: 'tenderee-guarantee',
    component: tenderee_guarantee
  },
  {
    path: "pay-supplier-detail",
    name: "pay-supplier-detail",
    component: pay_supplier_detail
  },
  {
    path: "pay-supplier-view",
    name: "pay-supplier-view",
    component: pay_supplier_view
  },
  {
    path: "pay-supplier-list",
    name: "pay-supplier-list",
    component: pay_supplier_list
  },
      {
          path: "reaccreditation-conclusion-view-main",
          name: "reaccreditation-conclusion-view-main",
          component: reaccreditation_conclusion_view_main
      },
      {
          path: "statistics-analysis/index",
          name: "statistics_analysis_index",
          component: statistics_analysis_index
      },
      {
          path: "statistics-analysis/list",
          name: "statistics-analysis-list",
          component: statistics_analysis_list
      },
      {
          path: "statistics-analysis/field-info",
          name: "statistics-analysis-field-info",
          component: statistics_analysis_field_info
      },
  ]
}
export default indexRouter





// WEBPACK FOOTER //
// ./src/router/src/main.js